import React from 'react';
import clsx from 'clsx';
import { Belonging } from '@spike/belonging-model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import Spinner from 'components/UI/V3/Spinner';
import styles from './Belongings.module.scss';

interface BelongingsTableProps {
    belongings: Array<Belonging>;
    loading: boolean;
    onEdit: (belonging: Belonging) => void;
    onDelete: (belonging: Belonging) => void;
}

export const BelongingsTable: React.FC<BelongingsTableProps> = ({ belongings, loading, onEdit, onDelete }) => {
    if (loading && belongings.length === 0) {
        return (
            <div className={styles.spinnerContainer}>
                <Spinner size={24} />
            </div>
        );
    }

    return (
        <div className={styles.table}>
            <div className={styles.tableHeader}>
                <span>Belonging</span>
            </div>
            <div className={styles.tableBody}>
                {belongings.map(belonging => (
                    <div
                        key={belonging.id}
                        className={styles.tableRow}
                    >
                        <span
                            className={styles.belongingName}
                            title={belonging.name}
                        >
                            {belonging.name}
                        </span>
                        <div className={styles.actions}>
                            <FontAwesomeIcon
                                icon={faPencil}
                                className={clsx(styles.actionIcon, loading && styles.disabled)}
                                onClick={() => !loading && onEdit(belonging)}
                            />
                            <FontAwesomeIcon
                                icon={faTrashAlt}
                                className={clsx(styles.actionIcon, loading && styles.disabled)}
                                onClick={() => !loading && onDelete(belonging)}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BelongingsTable;
